import React from "react";
import styled from "styled-components";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Api from "../classes/Api";
import Translation from "../classes/Translation";
const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

    const FeastContainer = styled.div`
        text-align: -webkit-center;
        backgroundColor: white;
        height: auto;
    `;

    const ProjectsContainer = styled.div`
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        border: 0;
        margin: 0;
        border: 0;
        padding: 0;
        padding-top: 50px;

        & .project{
            min-width: 320px;
            width: auto;
            height: auto;
            padding: 10px;
            margin: 0;
            border: 0;

            img{
                width: 320px;
                height: auto;
                box-shadow: 2px 2px 5px 0px rgb(0 0 0 / 30%);
                -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.3);
                -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.3);
            }

            p{
                text-align: center;
            }
        }
    `;

    const BackButtonWrapper = styled.div`
        display: flex;
        justify-content: center;
        position: fixed;
        background: white;
        width: calc(70vw - 16px);
        border-bottom: 1px solid #dbdbdb;
        padding-bottom: 10px;
        z-index: 1;
        .backButton{ 
            ${'' /* transform: translateX(-50%); */}
        }

        @media (max-width: 1023px){
            width: calc(100vw - 16px);
        }
    `;

export default class TemplateBank extends React.PureComponent{
    constructor(props){
        super(props);
        this.state = {
            position: 0,
            feasts: [],
            projects: [],
            feastClickedKey: undefined
        };
    }

    componentDidMount(){
        this.fetchFeastsData();
    }

    fetchFeastsData = (position=0) => {
        let form = new FormData();
        form.append('id_projects_groups', this.props.object.id_projects_groups);
        form.append('position', this.state.position);
        form.append('is_poroject', 'tak');
        form.append('interfacelanguage',  this.props.selectedLanguage);
        
        fetch(`/modules/new_creator/ajax/get_feasts.php`,
            {
                method: 'POST',
                body: form
            }
        )
        .then(data => data.json())
        .then(json => {
            this.setState({feasts: json})
            this.fetchProjectData();
        });
    }

    fetchProjectData = () => {
        let tabId = this.state.feastClickedKey ? JSON.stringify([this.state.feasts[this.state.feastClickedKey].id_feast]) : [];

        Api.getProjectGroup(this.props.object.id_projects_groups, tabId, this.props.selectedLanguage)
        .then(data => data.json())
        .then(json => {
            this.setState({
                projects: json.projects
            })
        });
    }

    onClickFeast = (e) => {
        const key = e.currentTarget.getAttribute("feastkey");
        this.setState({
            feastClickedKey: key,
            projects: []
        }, () => {
            this.fetchProjectData();
        });
        
    }

    onClickBackButton = (e) => {
        this.setState({
            feastClickedKey: undefined,
            projects: []
        }, () => {
            this.fetchProjectData();
        })
    }

    onClickProject = (e) => {
        let projectId = e.currentTarget.getAttribute('projectid');
        this.props.replaceProject(this.props.object, projectId, () => {
            this.props.closeModal(e, this.props.tabindex);
        });
        
    }

    render(){
        const { feasts, projects, feastClickedKey } = this.state;
        const feastElements = feasts.map((feast, key) => {
            return (
                <div 
                    className={"modal_table highlight_" + feast.highlighted}
                    key={ feast.id_feast }
                    feastkey={ key }
                    onClick={this.onClickFeast}
                >
                    <a>
                        <h4>
                            { feast.name }
                        </h4>
                        <div className="arrow">►</div>
                    </a>
                </div>
            );
        })

        const projectElements = projects.map(project => {
            return(
                <div
                    className="project"
                    projectid={ project.id_project }
                    onClick={this.onClickProject}
                >
                    <LazyLoadImage
                        src={ project.cover }
                        height={320}
                        effect="blur"
                    />
                    <p>
                        { project.project_number }
                    </p>
                </div>
            )
        });

        return(
            <React.Fragment>
                <FlexContainer>
                    { 
                        feastClickedKey &&
                        <BackButtonWrapper
                            onClickCapture={this.onClickBackButton}
                        >
                            <span className="btn btn-primary return_btn backButton">← {Translation.getTranslation('back')}</span>
                        </BackButtonWrapper>
                    }
                    <FeastContainer
                        feastClickedKey={feastClickedKey}
                    >
                        { 
                            !feastClickedKey && 
                            feastElements
                        }
                    </FeastContainer>
                    <ProjectsContainer
                        feastClickedKey={feastClickedKey}
                    >
                        { projectElements }
                    </ProjectsContainer>
                </FlexContainer>
            </React.Fragment>
        );
    }
}